import { types } from 'mobx-state-tree';

export const CaseReferenceModel = types.model('CaseReferenceModel', {
  referenceApplicationGID: types.maybe(types.string),
  applicationGID: types.maybe(types.string),
  caseNumber: types.maybe(types.string),
  childEntityType: types.maybe(types.integer),
  parentEntityType: types.maybe(types.integer),
  owner: types.maybe(types.string),
  purpose: types.maybe(types.string),
  isOwner: types.maybe(types.boolean)
});
